/**
 * @file Resource Selection.
 */

/**
 * Resource Selection component.
 */
const vResourceSelection = () => {
	const resourceSelection = document.querySelector('.v-resource-selection');

	if (!resourceSelection) {
		return;
	}

	const filterDropDown = document.querySelector(
		'.v-resource-selection__c-select'
	);
	const options = filterDropDown.querySelectorAll('.v-resource-selection__c-select-option');
	const filterDropDownText = document.querySelector(
		'.v-resource-selection__c-select-btn-text'
	);

	if(filterDropDown) {
		document.addEventListener('click', (event) => {
			if (!filterDropDown.contains(event.target)) {
        filterDropDown.classList.remove("active");
    	}
		});
	}

	const resourceElements = document.querySelectorAll(
		'.v-resource-selection__link',
	);
	const resourcesList = [...resourceElements].map((el) => ({
		text: el.text,
		url: el.getAttribute('href'),
		className: 'v-resource-selection__link',
		tags: el.getAttribute('data-resource-tags') ?? []
	}));

	filterDropDown.addEventListener('click', () => {
		filterDropDown.classList.toggle('active');
	});

	options.forEach(option => {
		option.addEventListener('click', () => {
			options.forEach(opt => {
				opt.classList.remove('selected');
			});
			option.classList.add('selected');

			const searchTerm = option.querySelector('.v-resource-selection__c-select-option-text').getAttribute('data-option-value');
			const filterTags = option.querySelector('.v-resource-selection__c-select-option-text').getAttribute('data-filter-tags')
			filterDropDownText.textContent = searchTerm || 'Filter Resources';

			resourcesList.forEach((resources, index) => {
				resourceElements[index].style.display = 'block';
			});
			resourcesList.forEach((resource, index) => {
				if (searchTerm === '') {
					resourceElements[index].style.display = 'block';
				} else {
					// Search using tags
					if(filterTags && filterTags !== 'null') {
						const tags = JSON.parse(filterTags);
						const tagMatched = tags.some(tag => resource.tags.includes(tag));
						if (!tagMatched) {
							resourceElements[index].style.display = 'none';
						}
						return tagMatched;
					}

					// Search using term
					const searchTerms = searchTerm
						.toLowerCase()
						.replace(/\s{2,}/g, ' ')
						.split(' ');

					searchTerms.some((term) => {
						const searchMatched = resource.text.toLowerCase().includes(term);
						if (!searchMatched) {
							resourceElements[index].style.display = 'none';
						}
						return searchMatched;
					});
				}
			});
		});
	});

	// filterDropDown.addEventListener('change', (e) => {
	// 	e.preventDefault();
	// 	const searchTerm = e.target.value;
	// 	resourcesList.forEach((resources, index) => {
	// 		resourceElements[index].style.display = 'block';
	// 	});
	// 	resourcesList.forEach((resource, index) => {
	// 		if (searchTerm === '') {
	// 			resourceElements[index].style.display = 'block';
	// 		} else {
	// 			const searchTerms = searchTerm
	// 				.toLowerCase()
	// 				.replace(/\s{2,}/g, ' ')
	// 				.split(' ');
	// 			searchTerms.some((term) => {
	// 				const searchMatched = resource.text.toLowerCase().includes(term);
	// 				if (!searchMatched) {
	// 					resourceElements[index].style.display = 'none';
	// 				}
	// 				return searchMatched;
	// 			});
	// 		}
	// 	});
	// });
};

export default vResourceSelection;
